// Footer.js
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <>
      {/* <!-- Start Footer aera --> */}
      <footer className="rbt-footer footer-style-1">
        <div className="footer-top">
          <div className="container">
            <div className="row row--15 mt_dec--30">
              <div className="col-lg-4 col-md-6 col-sm-6 col-12 mt--30">
                <div className="footer-widget">
                  <div className="logo">
                    <Link to="/">
                      <img src="/assets/images/capital_clothes_logo-275x65.png" alt="Edu-cause" />
                    </Link>
                  </div>

                  <p className="description mt--20">
                    Founded in 2010, Capital Custom Clothiers has quickly become the premier destination
                    for custom tailoring and fine menswear in Annapolis, Maryland. We specialize in
                    crafting modern, sophisticated garments and Ready-to-Wear pieces using time-honored
                    techniques—each one handmade by our skilled and passionate team. Every Capital Custom
                    piece is a testament to meticulous craftsmanship, thoughtful design, and unparalleled
                    service. Built to endure, designed to impress, and made to be worn for a lifetime.
                  </p>

                  <div className="contact-btn mt--30">
                    <a
                      className="rbt-btn hover-icon-reverse btn-border-gradient radius-round"
                      href="mailto:support@capitalclothiers.net"
                    >
                      <div className="icon-reverse-wrapper">
                        <span className="btn-text">Contact Us</span>
                        <span className="btn-icon"><i className="feather-arrow-right"></i></span>
                        <span className="btn-icon"><i className="feather-arrow-right"></i></span>
                      </div>
                    </a>
                  </div>
                </div>
              </div>

              <div className="offset-lg-1 col-lg-2 col-md-6 col-sm-6 col-12 mt--30">
                <div className="footer-widget">
                  <h5 className="ft-title">How to </h5>
                  <ul className="ft-link">
                    <li><Link to="/TrackOrder">Track Your Order</Link></li>
                    <li><a href="/return-instructions">Return A Product</a></li>
                    <li><a href="13-university-classic.html">Evaluate Your Fit</a></li>
                    <li><a href="/request-remake">Request A Remake</a></li>
                    {/* <li><a href="faqs.html">Create a custom shirt</a></li> */}
                  </ul>
                </div>
              </div>

              <div className="col-lg-2 col-md-6 col-sm-6 col-12 mt--30">
                <div className="footer-widget">
                  <h5 className="ft-title">Support </h5>
                  <ul className="ft-link">
                    <li><Link to="/faq">FAQs</Link></li>
                    <li><a href="/help">Help Articles</a></li>
                    <li><a href="/perfect-fit">Perfect Fit Guarantee</a></li>
                    <li><a href="/return-policy">Return And Remake Policy</a></li>
                    <li><a href="/shipping-delivery">Shipping Times</a></li>
                  </ul>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-sm-6 col-12 mt--30">
                <div className="footer-widget">
                  <h5 className="ft-title">Company</h5>
                  <ul className="ft-link">
                    <li><a href="/about">About us</a></li>
                    {/* <li><a href="become-a-teacher.html">Sustainability</a></li> */}
                    <li><a href="https://www.google.com/search?sca_esv=4c83e8cc851d4e9c&rlz=1C5CHFA_enIN1171IN1172&sxsrf=AE3TifPg0Z0oHcgH1IpVUgV2riQf7eWBqA:1766080012920&si=AMgyJEuzsz2NflaaWzrzdpjxXXRaJ2hfdMsbe_mSWso6src8s2JFtP9W08WfLWa8q8kWXc_PulEaQEnK4tUubiKFPuGkf3AaElbYCe93wS_bwtDp1ojLLDEvAifwCT894EEqPSAidFax_DJt-ZV2FnNDRQJg4h3hiA%3D%3D&q=Capital+Custom+Clothiers+Reviews&sa=X&ved=2ahUKEwi2q8Le2MeRAxX9gK8BHXMSK6wQ0bkNegQIIxAE&biw=1728&bih=996&dpr=2#lrd=0x89b7f64e37063353:0xe941f08190fdbf87,3,,,,">Customer Reviews</a></li>
                  </ul>
                  <ul className="social-icon social-default icon-naked justify-content-start mt--20">
                    <li><a href="https://www.facebook.com/CapitalCustomClothiers/"><i className="feather-facebook"></i></a></li>
                    <li><a href="https://x.com/Cap_Clothiers"><i className="feather-twitter"></i></a></li>
                    <li><a href="https://www.instagram.com/capitalcustomclothiers/"><i className="feather-instagram"></i></a></li>
                    {/* <li><a href="https://in.pinterest.com/capitalcustomclothiers/"><i className="feather-pinterest"></i></a></li> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      {/* <!-- End Footer aera --> */}

      <div className="rbt-separator-mid">
        <div className="container">
          <hr className="rbt-separator m-0" />
        </div>
      </div>

      {/* <!-- Start Copyright Area  --> */}
      <div className="copyright-area copyright-style-1 ptb--20">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-12">
              <p className="rbt-link-hover text-center text-lg-start">
                Copyright © {new Date().getFullYear()} Capital Custom Clothier . All Rights Reserved
              </p>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-12">
              <ul className="copyright-link rbt-link-hover justify-content-center justify-content-lg-end mt_sm--10 mt_md--10">
                <li><a href="/terms-and-conditions">Terms of service</a></li>
                <li><a href="/privacy-policy">Privacy policy</a></li>
                <li><a href="subscription.html">Subscription</a></li>
                <li><a href="/login">Login & Register</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- End Copyright Area  --> */}
    </>
  );
};

export default Footer;
